<template>
  <footer class="full-foot bgc-f8f8f8 c-333 p-r ov-h">
    <div class="">
      <div class="fw-500 c-222">Subscribe to our newsletter</div>
      <div class="fs-14 c-999 sign-text">Sign up for monthly newsletter regarding our products, events and news.</div>
      <!-- <form class="d-f jc-sb ai-c full-foot-form" id="subscribe-info">
        <input type="text" placeholder="First name" id="firstName" autocomplete="off" class="fs-16" />
        <input type="text" placeholder="Last name" id="lastName" autocomplete="off" class="fs-16" />
        <input type="text" placeholder="Email address" id="subscribeEmail" autocomplete="off" class="fs-16" />
        <button type="button" class="bgc-222 fs-16 c-fff c-p" id="btnSubscribe">Subscribe</button>
      </form> -->
      <Form ref="formValidate" class="footer-form" :model="formValidate" :rules="ruleValidate" inline>
        <FormItem prop="firstName">
          <Input v-model="formValidate.firstName" placeholder="First name"></Input>
        </FormItem>
        <FormItem prop="lastName">
          <!-- <Input v-model="formValidate.lastName" placeholder="Last name"></Input> -->
          <Select v-model="formValidate.lastName" placeholder="Select Industry">
            <Option v-for="item in industryList" :value="item.value" :key="item.value">{{ item.value }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="email">
          <Input v-model="formValidate.email" placeholder="Email address"></Input>
        </FormItem>
        <button @click="handleSubmit('formValidate')" type="button" class="bgc-222 fs-16 c-fff c-p" id="btnSubscribe">
          Subscribe
        </button>
      </Form>
      <div class="subscribe-tips ta-c fs-14 c-f00" id="subscribeTips"></div>
      <div class="d-f full-foot-nav">
        <hr class="line1" />
        <div>
          <strong
            ><a href="/product"
              >Product <span class="triangle-icon triangle-icon-000 bgs-cover bgp-c p-a tr-180 in-h5"></span
            ></a>
          </strong>
          <div>
            <!-- <a href="/product/autosteeringkit"> Autosteering Kit</a>
            <a href="/product/al01-3d-land-leveling-system">AL01 3D Land Leveling System</a>
            <a href="/product/excavatorguidance"> 3D Excavator Guidance System</a>
            <a href="/product/piledriver">Smart Pile Driver Guidance System</a>
            <a href="/product/trion-s1-3d-lidar-scanner">Trion S1 3D LiDAR Scanner</a>
            <a href="/product/lawnmower"> Lawnmower</a>
            <a href="/product/Powersec">PowerSec</a>
            <a href="/product/basestation">RTK Base Station</a>
            <a href="/product/wificamera">Wi-Fi Camera</a> -->
            <a href="/product/fjd-connect">FJD Connect Farm Management Platform</a>
            <a href="/product/autosteeringkit">FJD AT1 Autosteering Kit</a>
            <a href="/product/al01-3d-land-leveling-system">FJD AL01 3D Land Leveling System</a>
            <a href="/product/fjd-easy-dig-g21-2d-excav">FJD Easydig G21 2D Excavator Guidance System</a>
            <a href="/product/excavatorguidance">FJD G31 3D Excavator Guidance System</a>
            <a href="/product/piledriver">FJD G32 Smart Pile Driver Guidance System</a>
            <a href="/product/basestation">FJD Satellite Navigation Base Station</a>
            <a href="/product/wificamera">FJD Wi-Fi Camera</a>
            <a href="/product/aerial-mapper">FJD Trion O1 AerialMapper</a>
            <a href="/product/trion-s1-3d-lidar-scanner">FJD Trion S1 3D LiDAR Scanner</a>
            <a href="/product/trion-v1-series-rtk-rover">FJD Trion V1 Series RTK Rover</a>

            <a href="/product/lawnmower">FJD Vidar Z42P Smart Lawn Mower</a>
            <a href="/product/powersec">FJD PowerSec MP2000 Portable Power Station</a>
          </div>
        </div>
        <div>
          <strong
            ><a href="/blog"
              >News <span class="triangle-icon triangle-icon-000 bgs-cover bgp-c p-a tr-180 in-h5"></span></a
          ></strong>
          <div>
            <a href="/blog?name=CompanyNews">Company News</a>
            <a href="/blog?name=ProductUpdates">Product Updates</a>
            <a href="/blog?name=UserCase">User Case</a>
            <a href="/blog?name=Technology">Technology</a>
          </div>
        </div>
        <div>
          <strong
            ><a href="/contact"
              >Contact Us <span class="triangle-icon triangle-icon-000 bgs-cover bgp-c p-a tr-180 in-h5"></span></a
          ></strong>
          <div>
            <a href="/dealer" target="_blank">Become Dealer</a>
            <a href="/contact#email">Quotation</a>
            <a href="/contact#supply">Supply Chain </a>
            <a href="/contact#email">PR</a>
          </div>
        </div>
        <div>
          <strong
            ><a href="/about"
              >Explore FJD<span class="triangle-icon triangle-icon-000 bgs-cover bgp-c p-a tr-180 in-h5"></span></a
          ></strong>
          <div>
            <a href="/about">About FJD</a>
            <a href="/FJD-witness">FJD Witness</a>
            <a href="/webinarcenter">Webinar Center</a>
          </div>
        </div>
        <div>
          <strong
            ><a href="/support"
              >Support <span class="triangle-icon triangle-icon-000 bgs-cover bgp-c p-a tr-180 in-h5"></span></a
          ></strong>
          <div>
            <a href="/productservice">Product Service</a>
            <a href="/aftersalespolicy">After-Sales Policy</a>
            <a href="/shippingrates">Supply Chain</a>
            <a href="/videoList">Video Center</a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-f jc-sb ai-c slogan-social-media">
      <div class="fs-20 c-999 slogan">CREATE FOR A BETTER WORLD</div>
      <div class="social-media">
        <a href="//twitter.com/FJDynamics" target="_blank" class="d-ib twitter-black bgs-cover ti-_9999">twitter</a>
        <a href="//www.facebook.com/FJDynamicsglobal/" target="_blank" class="d-ib facebook-black ti-_9999 bgs-cover"
          >facebook</a
        >
        <a
          href="//www.youtube.com/channel/UCNuv_Ku3e95adnYs4mufAeA/featured?view_as=subscriber"
          target="_blank"
          class="d-ib ti-_9999 youtube-black bgs-cover"
          >youtube</a
        >
        <a
          href="//www.linkedin.com/company/fjdynamicsglobal/?viewAsMember=true"
          target="_blank"
          class="d-ib linkedin-black ti-_9999 bgs-cover"
          >linkedin</a
        >
        <a
          href="//instagram.com/fjdynamics?igshid=e5vkxd17plf0"
          target="_blank"
          class="d-ib instagram-black ti-_9999 bgs-cover"
          >instagram</a
        >
      </div>
    </div>
    <hr class="line2" />
    <div class="d-f jc-fs fw-w ai-c fs-14 copyright">
      <div>© 2022 FJDYNAMICS PTE.LTD. All Rights Reserved.</div>
      <div>
        <a href="/cookiepolicy" class="">Cookie Policy</a>
        <a href="/privacypolicy" class="">Privacy Policy</a>
        <a href="/sitemap" class="">SiteMap</a>
      </div>
      <div>Add: 15 SCOTTS ROAD #03-12 15 SCOTTS Singapore</div>
      <div>TEL: +65 8004922588, +1 833-330-6660</div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'FjFooter',
    data() {
      return {
        formValidate: {
          firstName: '',
          lastName: '',
          email: ''
        },
        ruleValidate: {
          firstName: [{ required: true, message: 'Please Enter your first name', trigger: 'blur' }],
          lastName: [{ required: true, message: 'Please Enter your last name', trigger: 'blur' }],
          email: [
            { required: true, message: 'Please Enter your e-mail', trigger: 'blur' },
            { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
          ]
        },
        industryList: [
          { value: 'Agriculture' },
          { value: 'Construction' },
          { value: 'Geospatial' },
          { value: 'Electric' },
          { value: 'Accessories' }
        ]
      }
    },
    created() {},
    mounted() {
      console.log('[ this.$route.query ] >', this.$route.query)
      // const
    },
    methods: {
      handleSubmit(name) {
        // console.log('[ sdsadasd ] >', 'sdsadasd')
        this.$refs[name].validate(async (valid) => {
          if (valid) {
            const { firstName, lastName, email } = this.formValidate
            const { data } = await this.$api.homeApi.subscribe({
              name: `${firstName} - ${lastName}`,
              email,
              languageCode: 'en-US',
              type: 0,
              utmSource: this.utmQuery && this.utmQuery.utm_source,
              utmCampign: this.utmQuery && this.utmQuery.utm_campaign,
              utmMedium: this.utmQuery && this.utmQuery.utm_medium,
              utmAdset: this.utmQuery && this.utmQuery.utm_adset,
              utmContent: this.utmQuery && this.utmQuery.utm_content
            })
            console.log('[ data ] >', data)
            this.$Message.success('Success!')
          } else {
            this.$Message.error('Fail!')
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  :deep(.ivu-form-item) {
    // width: 26.17%;
    width: 4.7rem;
    margin-right: 0.24rem;
    margin-bottom: 0;
  }
  /* 0526 foot */
  .full-foot {
    position: relative;
    padding-top: 3.96vw;
    padding-bottom: 2.08vw;
    padding-left: 0.56rem;
    padding-right: 0.56rem;
  }
  .full-foot .sign-text {
    margin-bottom: 0.24rem;
    margin-top: 0.08rem;
  }
  .full-foot .slogan {
    font-style: italic;
    line-height: 1.5;
  }
  .full-foot input {
    width: 100%;
    height: 36px;
    border: 1px solid #979797;
    box-sizing: border-box;
    text-indent: 10px;
    background-color: #fafafa;
  }
  .full-foot button {
    width: 3.26rem;
    height: 36px;
    position: relative;
    transform: perspective(1px) translateZ(0px);
    transition: background-color 0.3s linear;
  }
  .full-foot button:hover {
    background-color: #4a4a4a;
  }
  .full-foot-nav {
    margin-top: 0.54rem;
    margin-bottom: 0.48rem;
  }
  .full-foot-nav > div {
    width: auto;
    margin-left: 10%;
  }
  .full-foot-nav > div:nth-of-type(1) {
    margin: 0;
  }
  .full-foot-nav a {
    float: left;
    clear: both;
    font-size: 14px;
    color: #999;
    margin-bottom: 10px;
    line-height: 1.5;
  }
  .full-foot-nav strong a {
    color: #222;
    font-size: 18px;
    margin-bottom: 16px;
    font-weight: 500;
  }
  .full-foot-nav a:hover {
    color: #222;
  }
  .full-foot hr {
    margin: 0.83vw 0;
    border: none;
    border-top: 1px solid #e9e9e9;
  }
  .full-foot .social-media {
    display: flex;
    margin-right: 1.6vw;
  }
  .full-foot .slogan-social-media {
    align-items: flex-end;
  }
  .full-foot .social-media a {
    display: inline-block;
    width: 1.666vw;
    height: 1.666vw;
    font-size: 0;
    margin-right: 0.9375vw;
    background-size: cover;
    background-position: center;
    transition: transform 0.3s linear;
    will-change: transform;
  }
  .full-foot .social-media a:hover {
    transform: scale(1.1);
  }
  .full-foot .copyright div {
    margin-bottom: 10px;
  }
  .full-foot .copyright div,
  .full-foot .copyright a {
    color: #999;
    margin-right: 0.64rem;
  }
  .full-foot .copyright a:last-of-type {
    margin-right: 0;
  }
  .full-foot a:hover,
  .full-foot .copyright a:hover {
    color: #000;
  }
  // 表单修改样式
  .footer-form {
    display: flex;
    :deep(.ivu-input) {
      border-radius: 0;
      height: 36px;
      font-size: 16px;
      color: #333;
      &:hover {
        border-color: #dcdee2;
      }
      &:focus {
        border-color: #dcdee2;
        box-shadow: none;
      }
    }
    :deep(.ivu-select-selection) {
      border-radius: 0;
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      &:hover {
        border-color: #dcdee2;
      }
      &:focus {
        border-color: #dcdee2;
        box-shadow: none;
      }
    }
    :deep {
      .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
      .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 36px;
        line-height: 36px;
        font-size: 0.16rem !important;
        color: #333;
      }
      .ivu-select-item {
        color: #333;
        box-sizing: border-box;
        height: 0.4rem;
        line-height: 0.4rem;
        font-size: 0.16rem !important;
        padding: 0 0 0 0.48rem;
      }
      .ivu-select-dropdown {
        max-height: 220px;
      }
    }
  }
</style>
